import DialogComponent from "components/Dialog";

import Table from "components/Table";

import { ReactComponent as SpecialInfoIcon } from 'icons/components/specialInfo.svg';
import { ReactComponent as NotificationStopSaleIcon } from 'icons/components/notificationStopsale.svg';

import './index.less';

export default class InvoiceDetailDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
        };

        this.state = { ...this.defaultState };

        this.tableMap = {
            teeths: {
                label: "client.teeth",
            },
            title: {
                label: "main.work",
                size: "40%",
                type: "rows",
                style: "selectable",
                rows: ["title", { key: "altCode", label: "main.code", style: "second text p2" }],
            },
            price: {
                label: "main.price",
                callback: this.renderPrice.bind(this),
                /*type: "sum",*/
            },
            count: {
                label: "main.quantity",
                type: "number",
            },
            sum: {
                label: "main.sum",
                type: "sum",
            },
            discount: {
                label: "client.discount",
                type: "percent",
            },
            disc: {
                label: "treatmentPlan.totalWithDiscount",
                type: "sum",
                size: "120px"
            },
        };

        this.tablePaymentsMap = {
            createdTime: {
                label: "client.date",
                callback: this.createdTimeCell.bind(this),
                type: "dateTime",
            },
            createdBy: {
                label: "main.createBy",
                type: "doctor",
            },
            type: {
                label: "invoice.paymentSource",
                callback: this.typeCell.bind(this),
                /*
                type: "rows",
                rows: [
                    {
                        key: "type",
                        type: "select",
                        store: "transactionType",
                        nameKey: "name",
                        translate: true,
                    },
                ],
                */
            },
            hasCheck: {
                label: "main.check",
                type: "boolean",
            },
            comment: {
                label: "main.comment",
            },
            sum: {
                label: "main.sum",
                callback: this.renderSum.bind(this),
                /*type: "sum",
                size: "120px"*/
            },
        };
    }

    get dialogName() {
        return "invoiceDetailDialog";
    }

    get formClass() {
        return "w100 h100";
    }

    renderSum(value, map, { direction }) {
        if (direction === "DIRECTION_CANCEL")
            return "- " + this._helper.number.toSum(value);
        return this._helper.number.toSum(value);
    }

    renderPrice(value, map, { noDiscount }) {

        return (<div className="flex gap8">
            {noDiscount && <NotificationStopSaleIcon />}
            {this._helper.number.toSum(value)}
        </div>);
    }

    createdTimeCell(value) {
        const date = this._helper.date.toLocal(value);
        return this._helper.date.toDateTimeStr(date);
    }

    typeCell(value, map, { paymentWay }) {
        return (<div>{paymentWay.name}</div>);
    }

    show(info, changeTabCb) {
        this.info = info || {};
        this.changeTabCb = changeTabCb;
        this.isPrel = this.info.status === "PRE_CREATED";
        this.formTitle(this.info);
        super.show();
    }

    formTitle({ invoiceNumber, createdTime }) {
        const start = this.isPrel ? "treatmentPlan.provisionalBill" : "main.invoice";
        const { clientId, invoiceId } = invoiceNumber || {};
        const date = this._helper.date.toDateStr(createdTime);

        this.dialogTitle = `^${this.tr(start)} ${invoiceId}/${clientId} - ${date}`;
    }

    formatWorks(works) {
        let total = 0;
        let totalDisc = 0;
        const items = (works || []).map(it => {
            const { teeth, price, count, discount, noDiscount } = it;
            const teeths = this._helper.getTeethNames(teeth).join(", ");
            //const sum = (price || 0) * (count || 0) * (teeth?.length || 1);
            const sum = (price || 0) * (count || 0);
            let disc = sum;
            if (!noDiscount && discount)
                disc = this._helper.number.percentMinus(disc, discount);

            total += sum;
            totalDisc += disc;

            return { ...it, teeths, sum, disc };
        });

        return { items, total, totalDisc };
    }

    goToInvoice(isPrel, id) {
        this.hide();

        globalThis.invoicesTempScrollId = id;

        if (this.changeTabCb?.apply)
            this.changeTabCb(isPrel ? "forPayment" : "preliminary");
    }

    renderButtons() {
        return <></>;
    }

    insertDetailRow(text, value) {
        return (
            <div className="detailRow flex centerV gap8 text p1">
                <div className="rowText">{this.tr(text)}</div>
                <div className="flex1">{value || ""}</div>
            </div>
        );
    }

    renderMainInfo(info) {
        const { domainId, doctorId, assistantId, createdBy, changedBy, comment,
            treatmentTask, createdTime, changedTime, visit, fio, cancelComment } = info;
        const { activityDate } = treatmentTask || {};

        const createdTimeToLocal = this._helper.date.toLocal(createdTime);
        const changedTimeToLocal = this._helper.date.toLocal(changedTime);

        const clinic = this._helper.getClinicNameById(domainId);
        const docName = this._helper.getDoctorNameById(doctorId);
        const asstName = this._helper.getDoctorNameById(assistantId) || this.tr("main.notIndicated");
        const createdName = `${this._helper.getDoctorNameById(createdBy)} ${this._helper.date.toDateTimeStr(createdTimeToLocal)}`;
        const changedName = changedBy ? (`${this._helper.getDoctorNameById(changedBy)} ${this._helper.date.toDateTimeStr(changedTimeToLocal)}` || this.tr("main.notIndicated")) : "";
        const date = activityDate ? this._helper.date.toDateStr(activityDate) : this.tr("main.notIndicated");
        const visitDateTime = visit ? this._helper.date.toPeriodStr(visit.beginDate, visit.endDate) : "";

        return (
            <div className="borderBlock flex gap24 pad16 rad8">
                <div className="flex1 flex col gap8">
                    {this.insertDetailRow("login.clinic", clinic)}
                    {this.insertDetailRow("main.patient", fio)}
                    {this.insertDetailRow("client.doctor", docName)}
                    {this.insertDetailRow("client.assistant", asstName)}
                    {this.insertDetailRow("main.createdBy", createdName)}
                    {this.insertDetailRow("main.changedBy", changedName)}
                </div>
                <div className="flex1 flex col gap8">
                    {this.insertDetailRow("client.visit", visitDateTime)}
                    {this.isPrel && this.insertDetailRow("price.validity", date)}
                    {this.insertDetailRow("main.comment", comment)}
                    {cancelComment && this.insertDetailRow("Причина отмены счета", cancelComment)}
                </div>
            </div>
        );
    }

    insertWorksTitle({ childInvoices, parentInovice }) {
        const invoices = this.isPrel ? childInvoices : (parentInovice ? [parentInovice] : []);

        return (
            <div className="mainBlock flex centerV gap8 pad16 rad8">
                {this.isPrel && <SpecialInfoIcon />}
                <div className="text p1SemiBold">{this.tr("invoice", this.isPrel ? "detailWorksTitlePrel" : "detailWorksTitle")}:</div>
                {invoices.map((it, i) => {
                    const { /*invoiceNumber,*/ createdTime, id, clientId } = it;
                    //const { invoiceId, clientId } = invoiceNumber || {};
                    const end = this.isPrel ? "" : ` ${this.tr("main.from2")} ${this._helper.date.toDateStr(createdTime)}`;

                    return (
                        <div
                            key={i}
                            className="text p1 colLink hand"
                            onClick={this.goToInvoice.bind(this, this.isPrel, id)}
                        >
                            {`${id} / ${clientId} ${end.toLowerCase()}`}
                        </div>
                    );
                })}
            </div>
        );
    }

    renderAllWorks(info) {
        const { items, total, totalDisc } = this.formatWorks(info?.securedInvoiceItems);

        /*let sum = 0;
        items.forEach(it => {
            let amountAfterDeduction = it.sum - (it.sum * (it.discount / 100));
            sum += amountAfterDeduction;
        });*/

        return (
            <div className="flex col gap16">
                <div className="text blockTitle">
                    {this.tr("invoice.allWorks")}
                </div>
                {this.insertWorksTitle(info)}
                <div className="tableBlock rad8">
                    <Table
                        map={this.tableMap}
                        items={(items || []).sort((a, b) => a.sortIndex - b.sortIndex)}
                        scrollNo={true}
                        cantSort={true}
                        transparentBorder={true}
                    />
                </div>
                <div className="flex end gap24">
                    <div className="text p1 rowText">{this.tr("treatmentPlan.totalCost")}</div>
                    <div className="priceItem text p1SemiBold">{this._helper.number.toSum(total)}</div>
                </div>
                <div className="flex end gap24">
                    <div className="text p1 rowText">{this.tr("treatmentPlan.totalWithDiscount")}</div>
                    <div className="priceItem text p1SemiBold">{this._helper.number.toSum(totalDisc)}</div>
                </div>
            </div>
        );
    }

    renderHistory({ securedAccountHistory, totalSum, paidSum }) {
        const items = this.isPrel ? [] : (securedAccountHistory || []);
        let sum = 0;
        let sum2 = this.isPrel ? 0 : (totalSum - paidSum);

        if (!this.isPrel) {
            items.forEach(it => {
                if (it.direction === "DIRECTION_CANCEL")
                    sum -= (it.sum || 0);
                else
                    sum += (it.sum || 0);
            });
        }

        return (
            <div className="flex col gap16">
                <div className="text blockTitle">
                    {this.tr("invoice", this.isPrel ? "remainingWorks" : "paymentsHistory")}
                </div>
                <div className="tableBlock rad8">
                    <Table
                        map={this.isPrel ? this.tableMap : this.tablePaymentsMap}
                        items={items}
                        scrollNo={true}
                        cantSort={true}
                        transparentBorder={true}
                    />
                </div>
                <div className="flex end gap24">
                    <div className="text p1 rowText">{this.tr(this.isPrel ? "invoice.rest" : "invoice.amountOfPayments")}</div>
                    <div className="priceItem text p1SemiBold">{this._helper.number.toSum(sum)}</div>
                </div>
                <div className="flex end gap24">
                    <div className="text p1 rowText">{this.tr(this.isPrel ? "treatmentPlan.totalWithDiscount" : "client.duty")}</div>
                    <div className="priceItem text p1SemiBold colErr">{this._helper.number.toSum(sum2)}</div>
                </div>
            </div>
        );
    }

    renderContent() {
        return (
            <div className="content flex col gap24">
                {this.renderMainInfo(this.info)}
                {this.renderAllWorks(this.info)}
                {this.renderHistory(this.info)}
            </div>
        );
    }
}
